<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center h-full gap-3 px-6 text-center"
  >
    <span class="i-lucide-message-square-text size-12 text-n-slate-7" />
    <p class="text-base font-semibold text-n-slate-11">
      {{ t('INTERNAL_CHATS.EMPTY_STATE') }}
    </p>
    <p class="text-sm text-n-slate-9 max-w-xs">
      {{ t('INTERNAL_CHATS.EMPTY_STATE_HINT') }}
    </p>
  </div>
</template>
